import React, { useEffect } from "react";
import { Button, Icon, Popup } from "semantic-ui-react";

// Import Esri Components
import ZoomVM from "@arcgis/core/widgets/Zoom/ZoomViewModel";
import type MapView from "@arcgis/core/views/MapView";

interface Props {
  view: MapView;
}

export default function ZoomWidget(props: Props) {
  const [viewModel, setViewModel] = React.useState(null);
  const [minZoomed, setMinZoomed] = React.useState(false);
  const [maxZoomed, setMaxZoomed] = React.useState(false);

  // called on first load
  useEffect(() => {
    props.view.when((view) => {
      setViewModel(
        new ZoomVM({
          view: view,
        })
      );

      view.watch("zoom", () => {
        if (Number.isInteger(view.zoom)) {
          setMaxZoomed(view.constraints.effectiveMaxZoom === view.zoom);
          setMinZoomed(view.constraints.effectiveMinZoom === view.zoom);
        }
      });

      // Set the defaults
      setMaxZoomed(view.constraints.effectiveMaxZoom === view.zoom);
      setMinZoomed(view.constraints.effectiveMinZoom === view.zoom);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function handleZoom(zoomIn) {
    // check if the zoom is min or max and disable the appropriate zoom button
    if (viewModel.canZoomIn && zoomIn) {
      viewModel.zoomIn();
    } else if (viewModel.canZoomOut && !zoomIn) {
      viewModel.zoomOut();
    }
  }

  return (
    <Button.Group vertical icon>
      <Popup
        trigger={
          <Button
            className="no-focus"
            onClick={() => handleZoom(true)}
            disabled={maxZoomed}
          >
            <Icon name="plus" className="no-margin" />
          </Button>
        }
        inverted
        size="tiny"
        content="Zoom In"
        position="right center"
      />
      <Popup
        trigger={
          <Button
            className="no-focus"
            onClick={() => handleZoom(false)}
            disabled={minZoomed}
          >
            <Icon name="minus" className="no-margin" />
          </Button>
        }
        className={`transition fade in`}
        inverted
        size="tiny"
        content="Zoom Out"
        position="right center"
      />
    </Button.Group>
  );
}
